/**
 * Data layer for `free-trial-first-10-000-conversions-free-30-days`. Thin typed fetch wrappers over /api/v1/free-trial-first-10-000-conversions-free-30-days.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface FreeTrialFirst10000ConversionsFree30DaysRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListFreeTrialFirst10000ConversionsFree30DaysResponse {
	count: number;
	items: FreeTrialFirst10000ConversionsFree30DaysRow[];
}

export interface CreateFreeTrialFirst10000ConversionsFree30DaysBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/free-trial-first-10-000-conversions-free-30-days";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListFreeTrialFirst10000ConversionsFree30DaysResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListFreeTrialFirst10000ConversionsFree30DaysResponse>(res);
}

export async function create(body: CreateFreeTrialFirst10000ConversionsFree30DaysBody): Promise<FreeTrialFirst10000ConversionsFree30DaysRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<FreeTrialFirst10000ConversionsFree30DaysRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const freeTrialFirst10000ConversionsFree30DaysQueryKeys = {
	all: ["free-trial-first-10-000-conversions-free-30-days"] as const,
	list: () => [...freeTrialFirst10000ConversionsFree30DaysQueryKeys.all] as const,
	detail: (id: string) => [...freeTrialFirst10000ConversionsFree30DaysQueryKeys.all, id] as const,
};
